import { render, staticRenderFns } from "./DeleteAccountDialog.vue?vue&type=template&id=ec7ec1d0&lang=pug"
import script from "./DeleteAccountDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports